import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'इस छवि के लिए वैकल्पिक पाठ अनुपलब्ध है',
    noAnswers: "जवाब हेतु कोई विकल्प उपलब्ध नहीं, कृपया जारी रखने हेतु 'अगला' पर क्लिक करें",
    placeholder: 'कृपया निर्दिष्ट करें...',
    pleaseSelect: 'कृपया चुनें...',
    rotateLandscape: 'कृपया अपने फोन पर ओरिएंटेशन लॉक बंद करें और जारी रखने के लिए लैंडस्केप में घुमाएं।',
    rotatePortrait: 'कृपया जारी रखने के लिए आलेख से आलेख पर फोन घुमाएं।',
    ir: {
      selectWebCam: "अपने डिवाइस से अपलोड करने हेतु (अगर उपलब्ध हो तो) वेबकैम का चयन करें या 'ब्राउज़' पर क्लिक करें",
      noWebCam: 'वेबकैम उपलब्ध नहीं है',
      accessCamUpload: 'कैमरा का उपयोग करें/अपलोड करें',
      browse: 'ब्राउज़',
      uploadPhoto: 'कोई फोटो अपलोड करें',
      instead: 'इसके बजाय',
      capture: 'खीचें',
      somethingWrong: 'क्षमा करें, कुछ गलत हो गया। कृपया, बाद में पुनः प्रयास करें',
      couldntRead: 'क्षमा करें, हम कोड नहीं पढ़ सकें!',
      couldntProcess: 'क्षमा करें, हम आपकी तस्वीर को संसाधित नहीं कर सके!',
      moveOn: 'कृपया पुनः प्रयास करें या अपनी फोटो सबमिट करें और आगे बढ़ें',
      tryAgain: 'कृपया पुनः प्रयास करें',
      dataReceived: 'देटा प्राप्त हुआ!',
      enterManually: 'कृपया पुनः प्रयास करें या नीचे स्वयं डेटा प्रविष्ट करें',
      positionQR:
        'कृपया लाल फ्रेम में ठीक से आ सके इसके लिए क्यूआर कोड को अपने कैमरा के सामने रखें या इसे अपने कंप्यूटर से अपलोड करें।',
      analyzing: 'तस्वीर का विश्लेषण कर रहे हैं, कृपया प्रतीक्षा करें',
      submit: 'सबमिट करें',
      startOver: 'प्रारंभ करें',
      allDone: 'सब कुछ हो गया!',
      cantAnalyze:
        'ध्यान दें - हम इस छवि को प्रस्तुत नहीं कर सके। कृपया फिर से सबमिट करने का प्रयास करें या अधिक सामान्य इमेज फॉर्मेट (JPG, PNG, GIF, BMP) चुनें',
      wrongFormat:
        'हमें खेद है - हम इस फ़ाइल प्रारूप का समर्थन नहीं करते हैं। कृपया समर्थित इमेज प्रकार (JPG, PNG, GIF, BMP, TIF, PDF, SVG) अपलोड करें'
    },
    vr: {
      noWebCam: 'वेबकैम उपलब्ध नहीं है',
      uploadVideo: 'एक वीडियो अपलोड करें',
      skip: 'छोड़ दें?',
      accessCamUpload: 'कैमरा का उपयोग करें/अपलोड करें',
      browse: 'ब्राउज़',
      instead: 'इसके बजाय',
      or: 'या',
      stopRecording: 'रिकॉर्डिंग बंद करें',
      willBeStopped: 'रिकॉर्डिंग 5 मिनट पर बंद हो जाएगी',
      stopOnDone: 'जब आप पूरा कर लेंगे तब रिकॉर्डिंग बंद करें!',
      record: 'रिकॉर्ड',
      somethingWrong: 'क्षमा करें, कुछ गलत हो गया। कृपया, बाद में पुनः प्रयास करें',
      microphone: 'माइक्रोफ़ोन',
      camera: 'वेब कैमेरा',
      selectMicrophone: 'अपना माइक्रोफ़ोन चुनें',
      selectCam: 'अपना वेब कैमरा चुनें',
      upload: 'अपलोड',
      playback: 'प्लेबैक',
      stopPlayback: 'खेल को रोकें',
      submit: 'सबमिट करें',
      startOver: 'प्रारंभ करें',
      allDone: 'सब कुछ हो गया!',
      alternativeRecordSpan: 'कृपया, अपने कंप्यूटर से वीडियो-क्लिप अपलोड करें। वैकल्पिक<br/>&nbsp;',
      alrenativeRecordHref: 'रूप से आप एक वेबकैम के साथ वीडियो रिकॉर्ड कर सकते हैं।',
      cantAnalyze:
        'ध्यान दें - हम इस वीडियो को प्रस्तुत नहीं कर सके। कृपया फिर से सबमिट करने का प्रयास करें या अधिक सामान्य वीडियो फॉर्मेट (MP4, M4V, WEBPM) चुनें',
      wrongFormat:
        'हमें खेद है - हम इस फ़ाइल प्रारूप का समर्थन नहीं करते हैं। कृपया एक समर्थित वीडियो प्रकार (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV) अपलोड करें'
    },
    cjc: {
      choose: 'चुनें',
      pleaseChoose: 'कृपया चुनें',
      this: 'यह',
      one: 'एक',
      myChoice: 'मेरी पसंद'
    },
    hm: {
      addComment: 'कृपया नीचे एक टिप्पणी जोड़ें ',
      commentMandatoryPlaceHolder: 'कृपया अनिवार्य टिप्पणी जोड़ें ... ',
      commentOptionalPlaceHolder: 'कृपया वैकल्पिक टिप्पणी जोड़ें ... ',
      dragPin: 'स्थिति बदलने के लिए ड्रैग करें (सटीक पिन करने के लिए देर तक क्लिक / टैप करें)।',
      removePin: 'मिटाने के लिए इमेज के बाहर ड्रैग करें। ',
      editComment: 'टिप्पणी बदलने के लिए पिन पर क्लिक/टैप करें। ',
      addPin: 'कृपया नीचे दिए गए पैनल में से पिन ड्रैग करें और इसे इमेज पर अपनी पसंद की जगह पर छोड़ दें।',
      addPins: 'कृपया नीचे दिए गए पैनल में से पिन ड्रैग करें और उन्हें इमेज पर अपनी पसंद की जगह पर छोड़ दें। ',
      leavePins: (minPoints, maxPoints) =>
        `कृपया हर तरह की कम से कम ${minPoints} पिन छोड़ दें लेकिन ${maxPoints} पिन से अधिक नहीं।`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `कृपया कम से कम ${minPoints} पिन छोड़ दें लेकिन ${maxPoints} से अधिक नहीं।`,
      leavePinsWithOff: maxPoints =>
        `कृपया हर प्रकार की ${maxPoints} पिन से अधिक न छोड़ें या स्किप करने के लिए अगला पर क्लिक करें।`,
      leavePinsPerPageWithOff: maxPoints =>
        `कृपया ${maxPoints} पिन से अधिक न छोड़ें या स्किप करने के लिए अगला पर क्लिक करें।`,
      leavePinWithOff: 'कृपया हर प्रकार की 1 से अधिक पिन न छोड़ें या स्किप करने के लिए अगला पर क्लिक करें।',
      leavePinPerPageWithOff: 'कृपया 1 पिन से अधिक न छोड़ें या स्किप करने के लिए अगला पर क्लिक करें। . ',
      leaveExactlyPin: 'कृपया हर तरह की 1 पिन छोड़ें। ',
      leaveExactlyPinPerPage: 'कृपया 1 पिन छोड़ें। ',
      leaveExactlyPins: maxPoints => `कृपया हर तरह की ${maxPoints}  पिन छोड़ें। `,
      leaveExactlyPinsPerPage: maxPoints => `कृपया ${maxPoints}  पिन छोड़ें। `,
      leaveComment: 'टिप्पणी छोड़ने के लिए इमेज के नीचे टाइप करें। ',
      noAnswers: 'कोई उत्तर विकल्प नहीं, कृपया जारी रखने के लिए अगला पर क्लिक करें।',
      outOfPins: 'आप पिंनों से बाहर हैं',
      pinsBehavior:
        'जैसे-जैसे आप इमेज के साथ आगे बढ़ते हैं, आपको वो जगहें दिखेंगी जिन्हें एक पिन ड्रॉप के साथ हाइलाइट किया जाएगा।',
      clusters: 'आप केवल इन हाइलाइट की गई जगहों में ही पिन लगा पाएंगे।',
      contentAware: 'आप इन हाइलाइट की गई जगहों के अंदर या बाहर पिन ड्रॉप सकते हैं।'
    },
    mp: {
      expand_note: 'विस्तृत करने के लिए कृपया ऊपर होवर करें या छवि (छवियों) पर क्लिक करें',
      rb_note: rows =>
        `कृपया ${rows ? 'नीचे ' : ''}दिए गए प्रत्येक आइटम के लिए केवल 1 प्रतिक्रिया/प्रतिक्रियाएं चुनें:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'लागू होने वाले सभी की जाँच करें:'
        } else if (min === max) {
          return `कृपया ${rows ? 'नीचे ' : ''}दिए गए प्रत्येक आइटम के लिए${min !== 1 ? 'कोई भी' : 'केवल'} ${min} ${
            min !== 1 ? 'प्रतिक्रियाएं' : 'प्रतिक्रिया'
          } चुनें:`
        } else if (min > 0 && max < 5000) {
          return `कृपया ${rows ? 'नीचे ' : ''}प्रति आइटम कम से कम ${min} ${
            min !== 1 ? 'प्रतिक्रियाएं' : 'प्रतिक्रिया'
          } चुनें लेकिन ${max} से अधिक नहीं:`
        } else if (5000 === max && min > 0) {
          return `कृपया ${rows ? 'नीचे ' : ''}प्रति आइटम कम से कम ${min} ${
            min !== 1 ? 'प्रतिक्रियाएं' : 'प्रतिक्रिया'
          } चुनें:`
        } else if (0 === min && max < 5000) {
          return `कृपया ${rows ? 'नीचे ' : ''}प्रति आइटम ${max} से अधिक ${
            max !== 1 ? 'प्रतिक्रियाएं' : 'प्रतिक्रिया'
          } न चुनें:`
        } else {
          return 'लागू होने वाले सभी की जाँच करें:'
        }
      }
    },
    sh: {
      note: 'यदि आप किसी उत्पाद को स्टोर से खरीदना चाहते हैं तो उसे ज़ूम इन करने और अपने वर्चुअल कार्ट में जोड़ने के लिए उस पर क्लिक करें',
      amazonNote: 'ज़ूम इन करने के लिए किसी उत्पाद पर क्लिक करें और अपनी वर्चुअल कार्ट में जोड़ें.',
      fullCart: 'आपका कार्ट भर गया है!',
      qty: 'मात्रा',
      addToCart: 'कार्ट में जोड़ें',
      deleteFromCart: 'हटाएं',
      each: 'प्रत्येक',
      items: 'सामान',
      emptyCard: 'आपका कार्ट खाली है!',
      next: 'अगला',
      total: 'कार्ट',
      clearCart: 'कार्ट खाली करें',
      backToStore: 'स्टोर पर वापस जाएं',
      na: 'उपरोक्त में से कोई भी नहीं',
      maxCartCountError: max => `कृपया अपनी कार्ट में ${max} उत्पादों से अधिक नहीं जोड़ें `,
      scrollError: `इस सर्वे में आगे बढ़ने के लिए कृपया बाएं और दाएं पूरी तरह से स्क्रॉल करें। `,
      maxSpentError: max => `कृपया ${max} से अधिक नहीं खर्चें।`,
      maxProductCountError: max => `कृपया हर उत्पाद के लिए अपनी कार्ट में ${max} से अधिक की मात्रा नहीं जोड़ें।`
    },
    rb: {
      note: 'कृपया कम से कम 1 वर्ण लिखें।'
    },
    vo: {
      note: 'कृपया वीडियो को अंत तक देखें'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `कृपया ${min !== 1 ? 'किसी भी' : 'केवल'} ${min} वस्तु का चयन करें:`
        } else if (min > 0 && max < 5000) {
          return `कृपया कम से कम ${min} वस्तु पर चुनें, लेकिन ${max} प्रति कॉलम से अधिक नहीं चुनें:`
        } else if (5000 === max && min > 0) {
          return `कृपया कम से कम ${min} कवर्ण लिखें।:`
        } else if (0 === min && max < 5000) {
          return `कृपया ${max} वस्तु से अधिक नहीं चुनें:`
        } else {
          return 'लागू होने वाले सभी की जाँच करें:'
        }
      }
    },
    oe: {
      na: 'लागू नहीं',
      note: (min, max, optional) => {
        if (min === max) {
          return `कृपया टाइप करें ${1 !== min ? 'कोई भी' : 'बिल्कुल'} ${min} वर्ण${optional ? ' (वैकल्पिक)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `?कृपया कम से कम ${min} वर्ण टाइप करें लेकिन ${max}${optional ? ' (वैकल्पिक)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `कृपया कम से कम ${min} वर्ण टाइप करें${optional ? ' (वैकल्पिक)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `कृपया ${max} वर्ण से अधिक टाइप न करें${optional ? ' (वैकल्पिक)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'कृपया निम्नलिखित कोष्टकों को भरें:'
    },
    mx: {
      note: 'कृपया जारी रखने हेतु विशिष्ट रूप से दर्शाए गए स्लाइडर्स को सरकाएं',
      dragSlider: 'जवाब देने के लिए बाएं या दाएं खींचें'
    },
    psc: {
      dragLeftRight: 'जवाब देने के लिए बाएं या दाएं खींचें'
    },
    ps: {
      note: value => `कृपया नीचे दिए गए मदों के बीच शेष  ${value} को वितरित करें`,
      allDone: 'सब कुछ हो गया!',
      total: `संपूर्ण:`,
      dragSlider: 'जवाब देने के लिए बाएं या दाएं खींचें'
    },
    cx: {
      note: 'ड्रॉपबॉक्स खोलें और स्वत: स्क्रॉल करने के लिए अपना जवाब टाइप करना प्रारंभ करें या मैन्युअल रूप से उसका चयन करें'
    },
    ro: {
      note: 'पुनर्क्रमित करने के लिए ऊपर या नीचे खींचें:'
    },
    md: {
      note1:
        'कृपया अपनी पहली पसंद के आइटम पर क्लिक / टैप करें पसंद स्पष्ट करने के लिए फिर से क्लिक / टैप करें। अब कृपया अपनी अंतिम पसंद के आइटम पर क्लिक / टैप करें',
      note2: 'अब कृपया अपनी आख़िरी पसंद के आइटम पर क्लिक / टैप करें पसंद स्पष्ट करने के लिए फिर से क्लिक/टैप करें।',
      note3: 'धन्यवाद! अगले प्रश्न के लिए जाएं या शुरू करने के लिए किसी भी अचयनित आइटम पर क्लिक / टैप करें।'
    },
    aro: {
      note: 'कृपया प्रत्येक जोड़ी के लिए एक वस्तु चुनें।'
    },
    wd: {
      note: 'सुनिश्चित करें कि प्रत्येक अनुवर्ती मूल्य पिछले से अधिक है।'
    },
    emd: {
      note: 'कृपया वीडियो को अंत तक देखें',
      noAnswers: "जवाब हेतु कोई विकल्प उपलब्ध नहीं, कृपया जारी रखने हेतु 'अगला' पर क्लिक करें",
      start: 'शुरू करने के लिए क्लिक करें और दबाए रखें',
      resume: 'फिर से शुरू करने के लिए क्लिक करें और दबाए रखें',
      continue: 'आप तैयार हैं! <br/> जारी रखने के लिए आगे को दबाएं',
      continueMobile: 'आप तैयार हैं! <br/> जारी रखने के लिए यहां क्लिक करें',
      training: {
        session: 'प्रशिक्षण सत्र',
        note: 'कृपया प्रशिक्षण समाप्त करें',
        moveLeft: 'कृपया डायल को खींच कर पूरी तरह से बाईं ओर ले जाएं',
        moveBottom: 'कृपया डायल को खींच कर पूरी तरह से तल तक ले जाएं',
        moveRight: 'कृपया डायल को खींच कर पूरी तरह से दाईं ओर ले जाएं',
        moveTop: 'कृपया डायल को खींच कर पूरी तरह से शीर्ष पर ले जाएं',
        success: 'बहुत बढ़िया!'
      }
    },
    sft: {
      noAnswers: "जवाब हेतु कोई विकल्प उपलब्ध नहीं, कृपया जारी रखने हेतु 'अगला' पर क्लिक करें",
      note: 'कृपया जो विकल्प आपको सहज रूप से सही लगता है उसका जल्द से जल्द उत्तर के रूप में चयन करें',
      finish: 'आपने इसे पूरा कर लिया हैं! <br /> जारी रखने के लिए कृपया आगे पर क्लिक करें',
      training: {
        start:
          '<p>यह प्रश्न आपको तेजी से अलग-अलग शब्द दिखाएगा और इसके लिए आपकी एकाग्रता की आवश्यकता होगी। ' +
          'जवाब देने के लिए आपको तुरंत प्रतिक्रिया देनी होगी.</p> <p>क्या आप अभ्यास करने के लिए तैयार हैं?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `"{buttonLeft}" पर टैप करें`
            : (mouse ? `"{buttonLeft}" पर क्लिक करे` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `"{keyBtnLeft}" कुंजी दबाएं` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `"{buttonRight}" पर टैप करें`
            : (mouse ? `"{buttonRight}" पर क्लिक करें` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `"{keyBtnRight}" कुंजी दबाएं` : ''),
        fail: () => 'बहुत धीमा',
        success: () => 'बहुत बढ़िया!',
        finish: () =>
          '<p><strong> अति उत्तम!</strong></p><p>कृपया सुनिश्चित करें कि आप अगले </p><p>2-3 मिनट बिना विचलित हुए इस पर एकाग्रता से काम कर सकते हैं</p><p>तैयार होने पर शुरू करने के लिए आगे पर क्लिक करें</p>'
      },
      buttons: {
        start: 'शुरू करें',
        yesno: {
          left: 'हाँ',
          right: 'नहीं'
        },
        matches: {
          left: 'मेल खा रहा है',
          right: 'मेल नहीं खा रहा है'
        },
        fits: {
          left: 'उपयुक्त है',
          right: 'उपयुक्त नहीं है'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
